import BadgeNext from "ds/components/BadgeNext";
import Tree, { TreeBranch, TreeItem } from "ds/components/Tree";
import { AccessResult } from "utils/access";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import { useVisibilityToggle } from "components/Run/hooks/useVisibilityToggle";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import {
  RunApprovalPoliciesEntryList,
  RunApprovalPoliciesEntryType,
  RunEntryEvaluationProps,
  RunHistoryEntryType,
} from "../../types";
import ReviewForm from "./ReviewForm";
import Review from "./Review";
import Policies from "./Policies";

type ApprovalPoliciesEntryProps = RunEntryEvaluationProps & {
  canReview: AccessResult;
  list: RunApprovalPoliciesEntryList;
  openListByDefault: boolean;
  showReviewForm: boolean;
  stackId: string;
  runId: string;
  isModuleRun: boolean;
  runQueryToRefetch: string;
};

const ApprovalPoliciesEntry = ({
  canReview,
  list,
  openListByDefault,
  showReviewForm,
  evaluationLabel,
  evaluationBadgeVariant,
  evaluationTimestamp,
  stackId,
  runId,
  isModuleRun,
  runQueryToRefetch,
}: ApprovalPoliciesEntryProps) => {
  const [isOpen, toggle] = useVisibilityToggle(openListByDefault);

  const label = (
    <>
      <HistoryEntryLabel>
        <strong>Approval policies</strong> evaluated to
      </HistoryEntryLabel>
      <BadgeNext
        text={evaluationLabel.toUpperCase()}
        variant={evaluationBadgeVariant}
        type="strong"
      />
    </>
  );

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.ApprovalPolicies}
      timestamp={evaluationTimestamp}
      onClick={toggle}
      isOpen={isOpen}
      label={label}
      terminal
    >
      {isOpen && (
        <Tree padding="0 0 0 large">
          {showReviewForm && (canReview.result || !!canReview.message) && (
            <TreeBranch align="start">
              <TreeItem direction="column" autoHeight align="start">
                <ReviewForm
                  canReview={canReview}
                  runId={runId}
                  stackId={stackId}
                  runQueryToRefetch={runQueryToRefetch}
                />
              </TreeItem>
            </TreeBranch>
          )}

          {list.map((item) => {
            if (item.type === RunApprovalPoliciesEntryType.Policies) {
              return (
                <Policies
                  key={item.policies[0].id}
                  policies={item.policies}
                  runId={runId}
                  stackId={stackId}
                  isModuleRun={isModuleRun}
                />
              );
            }

            return <Review key={item.review.id} review={item.review} />;
          })}
        </Tree>
      )}
    </HistoryEntryWrapper>
  );
};

export default ApprovalPoliciesEntry;
